import { RootState } from '../../store';

export const getAddressesSelector = (state: RootState) => state?.ticketReducer?.addresses;
